import { render, staticRenderFns } from "./chooseSpeed.vue?vue&type=template&id=08d3bfef&"
import script from "./chooseSpeed.vue?vue&type=script&lang=ts&"
export * from "./chooseSpeed.vue?vue&type=script&lang=ts&"
import style0 from "./chooseSpeed.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports